/**
 * Suggested prompts for the V4 Enrich Workspace card.
 * PRIMARY_ENRICHMENT_PROMPTS — the three chips shown under the input.
 * SUGGESTED_ENRICHMENT_PROMPTS — full catalog (includes primary + extras).
 */
export const PRIMARY_ENRICHMENT_PROMPTS = [
  {
    id: "find-owner",
    label: "Find the company owner",
    text: "Find the company owner",
  },
  {
    id: "decision-makers",
    label: "Identify key decision makers",
    text: "Identify key decision makers",
  },
  {
    id: "summarize-business",
    label: "Summarize the business",
    text: "Summarize the business",
  },
];

export const SUGGESTED_ENRICHMENT_PROMPTS = [
  ...PRIMARY_ENRICHMENT_PROMPTS,
  {
    id: "recent-news",
    label: "Research recent company news",
    text: "Research recent company news",
  },
  {
    id: "competitors",
    label: "Identify competitors",
    text: "Identify competitors",
  },
  {
    id: "products-services",
    label: "Analyze products & services",
    text: "Analyze products and services",
  },
  {
    id: "hiring-trends",
    label: "Find hiring trends",
    text: "Find hiring trends",
  },
  {
    id: "funding-investors",
    label: "Research funding & investors",
    text: "Research funding and investors",
  },
];

export function findSuggestedEnrichmentPromptById(id) {
  return SUGGESTED_ENRICHMENT_PROMPTS.find((prompt) => prompt.id === id) || null;
}

export function findSuggestedEnrichmentPromptByText(text) {
  const normalized = String(text || "").trim();
  if (!normalized) return null;
  return (
    SUGGESTED_ENRICHMENT_PROMPTS.find(
      (prompt) => prompt.text.trim() === normalized
    ) || null
  );
}
